import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'

// 默认超时设置
axios.defaults.timeout = 50000;

// 环境的切换，产品开发时会有开发环境、测试环境、线上环境，通过这个来切换不同的接口基础地址
//http://wangys.1234ok.cn
//http://www.wanggenerator.com/
switch (process.env.NODE_ENV) {
    case 'development':
        // 开发环境使用相对路径，让请求先走前端代理，避免CORS问题
        axios.defaults.baseURL = '';
        break;
    case 'debug':
        axios.defaults.baseURL = 'https://www.zgfcraft.online/backend/';
        break;
    case 'production':
    default:
        axios.defaults.baseURL = 'https://www.zgfcraft.online/backend/';
}


axios.interceptors.request.use(function (config) {
    // 检查是否是admin/api请求
    const isAdminApi = config.url && config.url.startsWith('/admin/api');

    
    if(config.method === 'get'){
        // 统一加上时间戳
        config.params = config.params || {};
        config.params.t = +new Date();
        //get 请求下 参数在 params 中，其他请求在 data 中
        //一些参数处理
    }
    
    // 添加token认证信息 - 对/admin/api请求不添加token
    if (!isAdminApi) {
        const token = localStorage.getItem('token');
        if (token) {
            // 使用Authorization header传递token，格式为 "Bearer {token}"
            config.headers = config.headers || {};
            config.headers['Authorization'] = `Bearer ${token}`;
            
            // 同时也保留URL参数方式作为兼容（某些后端可能需要）
            if (config.method === 'get') {
                config.params = config.params || {};
                if (!config.params['access-token']) {
                    config.params['access-token'] = token;
                }
            }
        }
    }
    
    return config;
}, function (err) {
    return Promise.reject(err);
});

axios.interceptors.response.use(function (response) {
    //可以对返回的数据做一些统一处理，比如根据不同的 response.data.code 来判断，看是弹窗提示，还是跳转登录等
    return response;
}, function (err) {
    // 处理401未授权错误
    if (err.response && err.response.status === 401) {
        // 获取当前token
        const currentToken = localStorage.getItem('token');
        // 只有当本地确实存在token时，才执行清理和提示操作
        if (currentToken) {
            // 检查错误消息是否包含凭证相关的提示
            const errorMessage = err.response.data && err.response.data.message;
            if (errorMessage && (errorMessage.includes('凭证已过期') || errorMessage.includes('无效的凭证') || errorMessage.includes('invalid credentials'))) {
                // 清除本地的token和用户信息
                localStorage.removeItem('token');
                localStorage.removeItem('userInfo');
                // 清除Vuex中的状态
                if (window && window.store) {
                    window.store.commit('CLEAR_USER_INFO');
                }
                // 提示用户登录已过期或凭证无效
                Message.error('登录已过期或凭证无效，请重新登录');
                
                // 将用户重定向到主页
                if (window && window.location && window.location.pathname !== '/') {
                    window.location.href = '/';
                }
            }
        }
    }
    return Promise.reject(err);
});

/**
 * 封装 get
 * @param url
 * @param params
 * @returns {Promise}
 */
function fetch(url, params = {}, responseType = 'json') {
    console.log('Http.fetch被调用，URL:', url, '参数:', params);
    return new Promise(function (resolve, reject) {
        axios.get(url,{
            params: params,
            responseType: responseType
        })
        .then(function (response) {
            console.log('Http.fetch响应:', response);
            console.log('响应URL:', response.config.url);
            console.log('响应状态:', response.status);
            console.log('响应数据:', response.data);
            // 如果是blob类型，返回包含data和contentType的对象
            if (responseType === 'blob') {
                resolve({
                    data: response.data,
                    contentType: response.headers['content-type']
                });
            } else {
                // 其他类型直接返回data
                resolve(response.data);
            }
        })
        .catch(function (err) {
                console.error('Http.fetch请求失败:', err);
                console.error('错误URL:', url);
                console.error('错误详情:', err.response ? err.response : err);
                reject(err);
                
                // 详细的错误信息处理
                var msg = '';
                if (err.response) {
                    // 请求已发出，服务器返回状态码不在 2xx 范围内
                    const status = err.response.status;
                    const statusText = err.response.statusText;
                    const errorData = err.response.data;
                    
                    if (status === 400) {
                        msg = `请求错误 (${status}): ${url}`;
                    } else if (status === 401) {
                        msg = '未授权，请重新登录';
                    } else if (status === 403) {
                        msg = `拒绝访问 (${status}): ${url}`;
                    } else if (status === 404) {
                        msg = `请求地址不存在 (${status}): ${url}`;
                    } else if (status === 405) {
                        msg = `请求方法不允许 (${status}): ${url}`;
                    } else if (status >= 500) {
                        msg = `服务器内部错误 (${status}): ${statusText}`;
                    } else {
                        msg = `请求失败 (${status}): ${statusText}`;
                    }
                    
                    // 如果有具体的错误消息，优先使用
                    if (errorData) {
                        // 移除HTML标签的函数
                        const stripHtml = (html) => {
                            const div = document.createElement('div');
                            div.innerHTML = html;
                            return div.textContent || div.innerText || '';
                        };
                        
                        if (typeof errorData === 'string') {
                            // 移除字符串中的HTML标签
                            const cleanError = stripHtml(errorData);
                            msg = `${msg}: ${cleanError}`;
                        } else if (errorData.message) {
                            // 移除消息中的HTML标签
                            const cleanError = stripHtml(errorData.message);
                            msg = `${msg}: ${cleanError}`;
                        } else if (JSON.stringify(errorData) !== '{}') {
                            // 移除对象字符串表示中的HTML标签
                            const errorStr = JSON.stringify(errorData);
                            const cleanError = stripHtml(errorStr);
                            msg = `${msg}: ${cleanError}`;
                        }
                    }
                } else if (err.request) {
                    // 请求已发出，但没有收到响应
                    if (err.code === 'ECONNABORTED') {
                        msg = `请求超时 (${url})`;
                    } else if (err.message.includes('Network Error')) {
                        msg = `网络错误 (${url}): 请检查网络连接`;
                    } else if (err.code) {
                        msg = `请求错误 (${url}): ${err.code} - ${err.message}`;
                    } else {
                        msg = `请求未收到响应 (${url}): ${err.message}`;
                    }
                } else {
                    // 设置请求时发生错误
                    msg = `请求配置错误 (${url}): ${err.message}`;
                }
                
                // 输出详细错误信息到控制台
                console.error('详细错误信息:', msg);
                console.error('错误完整信息:', err);
                Message.error(msg);
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
function post(url, data = {}) {
    return new Promise(function (resolve, reject) {
        let config = {};
        let postData = data;
        
        // 如果是FormData对象，不需要序列化和设置Content-Type
        if (data instanceof FormData) {
            postData = data;
            // 添加access-token到FormData中
            const token = localStorage.getItem('token');
            if (token) {
                postData.append('access-token', token);
            }
        } else {
            // 添加access-token到普通对象中
            const token = localStorage.getItem('token');
            if (token) {
                postData = {
                    ...data,
                    'access-token': token
                };
            }
            postData = JSON.stringify(postData);
            console.log('POST请求数据序列化:', data);
            console.log('序列化后的数据:', postData);
            config.headers = {
                'Content-Type': 'application/json'
            };
        }
        
        axios.post(url, postData, config)
            .then(function (response) {
                // 这里一般情况就是根据约定好的 code 来进行处理，因为演示，所以直接 resolve 了
                // if(response.data.code === 200){
                //     //返回成功处理
                //     resolve(response.data);
                // } else {
                //     //错误处理
                // }
                console.log('Http.post响应:', response);
                console.log('响应URL:', response.config.url);
                console.log('响应状态:', response.status);
                console.log('响应数据:', response.data);
                resolve(response.data);
            })
            .catch(function (err) {
                console.error('Http.post请求失败:', err);
                console.error('错误URL:', url);
                console.error('错误详情:', err.response ? err.response : err);
                reject(err);
                
                // 详细的错误信息处理
                var msg = '';
                if (err.response) {
                    // 请求已发出，服务器返回状态码不在 2xx 范围内
                    const status = err.response.status;
                    const statusText = err.response.statusText;
                    const errorData = err.response.data;
                    
                    if (status === 400) {
                        msg = `请求错误 (${status}): ${url}`;
                    } else if (status === 401) {
                        msg = '未授权，请重新登录';
                    } else if (status === 403) {
                        msg = `拒绝访问 (${status}): ${url}`;
                    } else if (status === 404) {
                        msg = `请求地址不存在 (${status}): ${url}`;
                    } else if (status === 405) {
                        msg = `请求方法不允许 (${status}): ${url}`;
                    } else if (status >= 500) {
                        msg = `服务器内部错误 (${status}): ${statusText}`;
                    } else {
                        msg = `请求失败 (${status}): ${statusText}`;
                    }
                    
                    // 如果有具体的错误消息，优先使用
                    if (errorData) {
                        // 移除HTML标签的函数
                        const stripHtml = (html) => {
                            const div = document.createElement('div');
                            div.innerHTML = html;
                            return div.textContent || div.innerText || '';
                        };
                        
                        if (typeof errorData === 'string') {
                            // 移除字符串中的HTML标签
                            const cleanError = stripHtml(errorData);
                            msg = `${msg}: ${cleanError}`;
                        } else if (errorData.message) {
                            // 移除消息中的HTML标签
                            const cleanError = stripHtml(errorData.message);
                            msg = `${msg}: ${cleanError}`;
                        } else if (JSON.stringify(errorData) !== '{}') {
                            // 移除对象字符串表示中的HTML标签
                            const errorStr = JSON.stringify(errorData);
                            const cleanError = stripHtml(errorStr);
                            msg = `${msg}: ${cleanError}`;
                        }
                    }
                } else if (err.request) {
                    // 请求已发出，但没有收到响应
                    if (err.code === 'ECONNABORTED') {
                        msg = `请求超时 (${url})`;
                    } else if (err.message.includes('Network Error')) {
                        msg = `网络错误 (${url}): 请检查网络连接`;
                    } else if (err.code) {
                        msg = `请求错误 (${url}): ${err.code} - ${err.message}`;
                    } else {
                        msg = `请求未收到响应 (${url}): ${err.message}`;
                    }
                } else {
                    // 设置请求时发生错误
                    msg = `请求配置错误 (${url}): ${err.message}`;
                }
                
                // 输出详细错误信息到控制台
                console.error('详细错误信息:', msg);
                console.error('错误完整信息:', err);
                Message.error(msg);
            })
    })
}

export default {
    fetch,
    post
}
